import React from 'react';
import { FiInfo } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';

import UserGuideModal from './UserGuideModal';
import { GuideLauncherButton } from './style';
import { useGetUserGuideQuery } from 'services/api/userGuide';
import { hasRecentAnnouncements } from '../utils/userGuide';

export default function UserGuideLauncher() {
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(false);
  const supportedPaths = ['/', '/creative-preview'];
  const isSupportedPath = supportedPaths.includes(location.pathname);
  const { data, error, isFetching, isLoading } = useGetUserGuideQuery(
    undefined,
    {
      skip: !isSupportedPath,
      refetchOnMountOrArgChange: true,
    },
  );

  if (!isSupportedPath) return null;

  const errorMessage =
    error && 'data' in error
      ? String((error.data as any)?.error || 'Failed to load guide content.')
      : error
        ? 'Failed to load guide content.'
        : undefined;

  return (
    <>
      <GuideLauncherButton onClick={() => setIsOpen(true)} variant="light">
        <FiInfo />
        <span className="guide-launcher-label">Guides & Updates</span>
        {hasRecentAnnouncements(data) ? (
          <span className="guide-launcher-dot" />
        ) : null}
      </GuideLauncherButton>
      <UserGuideModal
        config={data}
        errorMessage={errorMessage}
        isLoading={isLoading || isFetching}
        onHide={() => setIsOpen(false)}
        show={isOpen}
      />
    </>
  );
}
